import { useAuth } from '@workos-inc/authkit-react';
import { api } from './client';

export function useConversationsList() {
  const { isLoading, user } = useAuth();

  const query = api.conversations.list.useQuery(undefined, {
    enabled: !isLoading && Boolean(user),
    retry: true,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    staleTime: 30 * 1000, // 30 seconds
  });

  // Sort conversations by updatedAt timestamp, most recent first
  const conversations = query.data ?? [];
  return conversations.sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
  );
}
